import React, { useState } from 'react';
import api from '../api';
import { useNavigate, Link } from 'react-router-dom';

const Register = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    phoneNumber: '',
    role: 'buyer',
    companyName: '',
    companyStreet: '',
    companyCity: '',
    companyZip: '',
    companyPhone: '',
    vatNumber: '',
    refundEmail: '',
  });

  const [message, setMessage] = useState('');
  const [errors, setErrors] = useState([]);
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [showPassword, setShowPassword] = useState(false); // 👈 Aggiunto toggle password

  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors([]);
    setMessage('');

    try {
      const response = await api.post('/auth/register', formData);
      setMessage('Registration successful! Please log in.');
      navigate('/login');
    } catch (error) {
      if (error.response?.data?.errors) {
        setErrors(error.response.data.errors);
      } else {
        setMessage('Registration failed. Please try again.');
      }
    }
  };

  return (
    <div className="container d-flex justify-content-center align-items-center mt-5">
      <div className="card p-4 shadow w-100" style={{ maxWidth: '700px' }}>
        <h3 className="text-center text-success mb-4">Register</h3>

        {message && <div className="alert alert-info text-center">{message}</div>}

        {errors.length > 0 && (
          <div className="alert alert-danger">
            <ul className="mb-0">
              {errors.map((err, idx) => <li key={idx}>{err.msg}</li>)}
            </ul>
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label fw-semibold">Account Type</label>
            <div>
              <div className="form-check form-check-inline">
                <input 
                  type="radio" id="buyer" name="role" value="buyer"
                  checked={formData.role === 'buyer'} onChange={handleChange}
                  className="form-check-input"
                />
                <label htmlFor="buyer" className="form-check-label">Buyer</label>
              </div>
              <div className="form-check form-check-inline">
                <input 
                  type="radio" id="seller" name="role" value="seller"
                  checked={formData.role === 'seller'} onChange={handleChange}
                  className="form-check-input"
                />
                <label htmlFor="seller" className="form-check-label">Seller</label>
              </div>
            </div>
          </div>

          <div className="mb-3">
            <label htmlFor="name" className="form-label">Full Name *</label>
            <input type="text" className="form-control" id="name" name="name" required
              value={formData.name} onChange={handleChange} />
          </div>

          <div className="mb-3">
            <label htmlFor="email" className="form-label">Email *</label>
            <input type="email" className="form-control" id="email" name="email" required
              value={formData.email} onChange={handleChange} />
          </div>

          {/* Password con toggle 👇 */}
          <div className="mb-3">
            <label htmlFor="password" className="form-label">Password *</label>
            <div className="input-group">
              <input
                type={showPassword ? 'text' : 'password'}
                className="form-control"
                id="password"
                name="password"
                required
                value={formData.password}
                onChange={handleChange}
              />
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => setShowPassword((prev) => !prev)}
                tabIndex={-1}
              >
                {showPassword ? 'Hide' : 'Show'}
              </button>
            </div>
          </div>

          <div className="mb-3">
            <label htmlFor="phoneNumber" className="form-label">Phone Number</label>
            <input type="text" className="form-control" id="phoneNumber" name="phoneNumber"
              value={formData.phoneNumber} onChange={handleChange} />
          </div>

          {formData.role === 'seller' && (
            <>
              <hr />
              <h5 className="text-success fw-bold mb-3">Company Info</h5>

              <div className="mb-3">
                <label htmlFor="companyName" className="form-label">Company Name *</label>
                <input type="text" className="form-control" id="companyName" name="companyName"
                  required value={formData.companyName} onChange={handleChange} />
              </div>

              <div className="mb-3">
                <label className="form-label">Company Address *</label>
                <div className="row">
                  <div className="col-md-4 mb-2">
                    <input type="text" className="form-control" placeholder="Street"
                      name="companyStreet" required value={formData.companyStreet}
                      onChange={handleChange} />
                  </div>
                  <div className="col-md-4 mb-2">
                    <input type="text" className="form-control" placeholder="City"
                      name="companyCity" required value={formData.companyCity}
                      onChange={handleChange} />
                  </div>
                  <div className="col-md-4">
                    <input type="text" className="form-control" placeholder="Zip"
                      name="companyZip" required value={formData.companyZip}
                      onChange={handleChange} />
                  </div>
                </div>
              </div>

              <div className="mb-3">
                <label htmlFor="companyPhone" className="form-label">Company Phone *</label>
                <input type="text" className="form-control" id="companyPhone" name="companyPhone"
                  required value={formData.companyPhone} onChange={handleChange} />
              </div>

              <div className="mb-3">
                <label htmlFor="vatNumber" className="form-label">VAT Number *</label>
                <input type="text" className="form-control" id="vatNumber" name="vatNumber"
                  required value={formData.vatNumber} onChange={handleChange} />
              </div>

              <div className="mb-3">
                <label htmlFor="refundEmail" className="form-label">Refund Email *</label>
                <input type="email" className="form-control" id="refundEmail" name="refundEmail"
                  required value={formData.refundEmail} onChange={handleChange} />
              </div>
            </>
          )}

          <div className="mb-3 form-check">
            <input type="checkbox" className="form-check-input" id="terms"
              checked={acceptedTerms} onChange={(e) => setAcceptedTerms(e.target.checked)} required />
            <label className="form-check-label" htmlFor="terms">
              I accept the <Link to="/terms" className="text-success text-decoration-none">Terms and Conditions</Link>
            </label>
          </div>

          <button type="submit" className="btn btn-success w-100 fw-bold">Register</button>

          <div className="mt-3 text-center">
            Already have an account?{' '}
            <Link to="/login" className="text-success fw-semibold text-decoration-none">
              Login here
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Register;
